import JustValidate from 'just-validate';
import axios from 'axios';
import newsletterModal from './modal';
import consentSolution from '../../gdpr/consent-solution';

// Posthog
import ph from '../../analytics/posthog/posthog-client';

declare let newsletter_object: any;

// Consent Solution
const modConsentSolution = new consentSolution();

// Modal
const modal = new newsletterModal();

export default class newsletterSubscribe{

    protected elForm: string;

    protected elBtn: string;

    protected elFormSpin: string = 'bgdrop-spin';

    protected call_rest_api: string;

    protected get_city: any = null;

    constructor(
        elForm: string,
        elBtn: string
    ) {
        
        this.elForm = elForm;

        this.elBtn = elBtn;

        this.call_rest_api = newsletter_object.rest_urls.subscribe;

        this.subscribe();

    }
    
    // Subscribe
    protected subscribe(){
        
        const form = document.querySelector(this.elForm);

        if(form == null){
            
            return;

        }

        // Show hidden fields
        this.showHiddenFields();

        // Validation
        const validation = new JustValidate(this.elForm, {
            errorFieldCssClass: 'is-invalid error-field-newsletter',
            errorLabelCssClass: 'just-validate-error-label error-label-newsletter',
            focusInvalidField: true,
            lockForm: true,
        });

        validation.addField('#field_newsletter_email', [
            {
                rule: 'required',
                errorMessage: newsletter_object.error_messages.email_required,
            },
            {
                rule: 'email',
                errorMessage: newsletter_object.error_messages.email_invalid,
            },
        ],
        {
            errorsContainer: form.querySelector('#error-mail'),
        })
        .addField('#field_newsletter_name', [
            {
                rule: 'required',
                errorMessage: newsletter_object.error_messages.name_required,
            },
        ])    
        .addField('#field_newsletter_privacy_policy', [
            {
                rule: 'required',
                errorMessage: newsletter_object.error_messages.check_privacy_policy,
            }
        ])
        .onSuccess((ev) => {

            ev?.preventDefault();

            // Send form
            this.sendForm();
        
        });

    }
    
    // Send form
    protected sendForm(){
        
        const _that = this;

        // Form element
        const form = document.querySelector(this.elForm) as HTMLFormElement;

        // Button element
        const btn = document.querySelector(this.elBtn) as HTMLButtonElement | null;

        // Form data
        const data = new FormData(form);

        // Variables for Posthog
        const varsPostHog = {
            'name': data.get('field_newsletter_name') as string,
            'email': data.get('field_newsletter_email') as string,
        };

        // Prepare data
        const datastring = new URLSearchParams(data as any).toString();

        // Post data
        const post_data = {
            'fields': datastring
        };
        
        // Query string
        const queryString = new URLSearchParams(post_data).toString();
            
        // Init spin
        const spin = this.btnSpin();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(this.call_rest_api, queryString, {
            
            validateStatus: function (status) {
                
                return status == 200;
                
            }

        })
        .then(function (response:any){

            // Remove spin
            spin.remove();
                    
            // Remove the disabled attribute
            btn?.removeAttribute('disabled');

            //  Get status
            const responseStatus:boolean = response.data.status;

            // Append message to body
            document.body?.insertAdjacentHTML('beforeend', response.data.message);

            if(responseStatus == true){         

                // Consent solution
                modConsentSolution.getConsent(_that.elForm);

                // Send event to posthog
                ph.captureNewsletterForm(
                    varsPostHog.name,
                    varsPostHog.email
                );

                // Open Modal
                modal.get('newsletter-subscribe-modal', 'newsletter-subscribe-modal-close');

                // Form reset
                form.reset();

                // Hide hidden fields
                _that.hideFields();

            }

        }).catch(function (error: any) {

            // Get status
            const errorStatus = error.response.status;
                
            if(errorStatus != null && errorStatus == 201){
                
                // Error message
                const errorMessage = error.response.data.message;

                // Append message to body
                document.body?.insertAdjacentHTML('beforeend', errorMessage);

                // Open modal
                modal.get('newsletter-subscribe-modal', 'newsletter-subscribe-modal-close');

            }

            // Remove spin
            spin.remove();
                    
            // Remove the disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Show hidden fields
     */
    protected showHiddenFields(){
        
        const el_mail = document.querySelector('#field_newsletter_email');
        const el_other = document.querySelector('#fields_newsletter_other');

        el_mail?.addEventListener("input", function (e) {
            e.preventDefault();

            const target = e.target as HTMLInputElement;

            const char = '@';

            if(target.value.toLowerCase().includes(char.toLowerCase()) === true){
            
                el_other?.classList.remove('hidden');
                el_other?.classList.add('flex');


            }else{

                el_other?.classList.remove('flex');
                el_other?.classList.add('hidden');
                
            }

        });

    }

    /**
     * Hide hidden fields
     */
    protected hideFields(){
        
        const el_other = document.querySelector('#fields_newsletter_other');

        el_other?.classList.remove('flex');
        el_other?.classList.add('hidden');

    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

}